/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ConsentResponse,
  HTTPValidationError
} from '.././model';

import { customCatchBackendFetcher } from '../../../client/customFetcher';




/**
 * Get a consent document by slug from Sanity CMS with status for the authenticated user.

Path Parameters:
- slug: The slug identifier for the consent document (e.g., "junction-hipaa-authorization")

Returns:
    ConsentResponse with the consent document details including portable text content and status
 * @summary Get Consent By Slug
 */
export const getConsentBySlugV1ConsentsSlugGet = (
    slug: string,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<ConsentResponse>(
      {url: `/v1/consents/${slug}`, method: 'GET', signal
    },
      );
    }
  



export const getGetConsentBySlugV1ConsentsSlugGetQueryKey = (slug?: string,) => {
    return [
    `/v1/consents/${slug}`
    ] as const;
    }

    
export const getGetConsentBySlugV1ConsentsSlugGetQueryOptions = <TData = Awaited<ReturnType<typeof getConsentBySlugV1ConsentsSlugGet>>, TError = HTTPValidationError>(slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConsentBySlugV1ConsentsSlugGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConsentBySlugV1ConsentsSlugGetQueryKey(slug);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConsentBySlugV1ConsentsSlugGet>>> = ({ signal }) => getConsentBySlugV1ConsentsSlugGet(slug, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(slug), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConsentBySlugV1ConsentsSlugGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetConsentBySlugV1ConsentsSlugGetQueryResult = NonNullable<Awaited<ReturnType<typeof getConsentBySlugV1ConsentsSlugGet>>>
export type GetConsentBySlugV1ConsentsSlugGetQueryError = HTTPValidationError


export function useGetConsentBySlugV1ConsentsSlugGet<TData = Awaited<ReturnType<typeof getConsentBySlugV1ConsentsSlugGet>>, TError = HTTPValidationError>(
 slug: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConsentBySlugV1ConsentsSlugGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConsentBySlugV1ConsentsSlugGet>>,
          TError,
          Awaited<ReturnType<typeof getConsentBySlugV1ConsentsSlugGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetConsentBySlugV1ConsentsSlugGet<TData = Awaited<ReturnType<typeof getConsentBySlugV1ConsentsSlugGet>>, TError = HTTPValidationError>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConsentBySlugV1ConsentsSlugGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConsentBySlugV1ConsentsSlugGet>>,
          TError,
          Awaited<ReturnType<typeof getConsentBySlugV1ConsentsSlugGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetConsentBySlugV1ConsentsSlugGet<TData = Awaited<ReturnType<typeof getConsentBySlugV1ConsentsSlugGet>>, TError = HTTPValidationError>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConsentBySlugV1ConsentsSlugGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Consent By Slug
 */

export function useGetConsentBySlugV1ConsentsSlugGet<TData = Awaited<ReturnType<typeof getConsentBySlugV1ConsentsSlugGet>>, TError = HTTPValidationError>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConsentBySlugV1ConsentsSlugGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetConsentBySlugV1ConsentsSlugGetQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




